/* eslint-disable import/no-cycle */
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormControlLabel,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { RoleEntity } from "../../../api/Role/Entity/RoleEntity";
import { protectedRoutes } from "../../../routes/protected";
import { useSelector } from "react-redux";
import { selectProfile } from "../../../store/profile/selector";
import ConfirmationDialog from "../../../shared/Components/ConfirmationDialog";

interface Props {
  isOpen: boolean;
  onSubmit(data: any): void;
  onClose(): void;
  defaultValue?: RoleEntity;
}

export function EditRoleDialog({
  isOpen,
  onSubmit,
  onClose,
  defaultValue,
}: Props) {
  const [name, setName] = useState("");
  const [access, setAccess] = useState<string[]>([]);
  const [validation, setValidation] = useState(false);
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const profile = useSelector(selectProfile);

  useEffect(() => {
    if (defaultValue) {
      setName(defaultValue.name);
      setAccess(defaultValue.access);
    }
  }, [defaultValue]);

  return (
    <>
      <ConfirmationDialog
        description="Are you sure you want to save the changes?"
        onCancel={() => setConfirmationDialog(false)}
        onClose={() => setConfirmationDialog(false)}
        open={confirmationDialog}
        onSubmit={() => {
          if (name !== "") {
            setConfirmationDialog(false);
            onSubmit({
              roleId: defaultValue!.id,
              binusianId: profile.binusianId,
              name,
              access,
            });
          } else {
            setConfirmationDialog(false);
            setValidation(true);
          }
        }}
      />
      <Dialog
        open={isOpen}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent className="flex flex-col gap-5">
          <FormControl className="gap-4">
            <Box className="flex gap-2">
              <Typography>Role Name</Typography>
              <Typography className="text-red-500">*</Typography>
            </Box>
            <TextField
              id="filled-basic"
              variant="outlined"
              className="bg-white"
              value={name}
              onChange={(e) => setName(e.target.value)}
              error={validation}
              helperText={validation && "Role Name is required!"}
            />
          </FormControl>
          <Box className="flex flex-col gap-2">
            <Box className="flex justify-between md:min-w-96">
              <Typography className="text-lg font-bold underline">
                Menu
              </Typography>
              <Typography className="text-lg font-bold underline">
                Access
              </Typography>
            </Box>
            {protectedRoutes
              .filter((r) => r.title !== "Home" && r.isEnabled)
              .map((e) => (
                <Box className="flex justify-between">
                  <Typography>{e.title}</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={access.includes(e.title)}
                        onChange={(el) =>
                          el.target.checked
                            ? setAccess((prev) => [...prev, e.title])
                            : setAccess((prev) =>
                                prev.filter((item) => item !== e.title)
                              )
                        }
                      />
                    }
                    label=""
                  />
                </Box>
              ))}
          </Box>
        </DialogContent>
        <DialogActions className="flex justify-center">
          <Button onClick={onClose} variant="contained" color="error">
            Cancel
          </Button>
          <Button
            onClick={() => setConfirmationDialog(true)}
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
